import { createContext, useContext, type PropsWithChildren } from "react";
import type { PlatformName } from "./types";

const PlatformNameContext = createContext<PlatformName | null>(null);

interface PlatformNameProviderProps extends PropsWithChildren {
  platform: PlatformName;
}

export function PlatformNameProvider({ platform, children }: PlatformNameProviderProps) {
  return <PlatformNameContext.Provider value={platform}>{children}</PlatformNameContext.Provider>;
}

export function usePlatformName(): PlatformName {
  const value = useContext(PlatformNameContext);
  if (value === null) {
    throw new Error("usePlatformName must be used within a PlatformNameProvider");
  }
  return value;
}
